import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.cancellation-reasons')
  .factory('$cancellationReasons', CancellationReasonsObjectFactory);

/* @ngInject */
function CancellationReasonsObjectFactory($bringozFactory: $bringozFactory,
                                          CancellationReasonsAPI: BringozApi,
                                          CancellationReasons_DS: DataStoreConfig) {

  function $cancellationReasons(id: string) {
    return $bringozFactory(id, CancellationReasonsAPI, CancellationReasons_DS)
  }

  return $cancellationReasons;
}
